import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OpsFeatures {

  codes: Codes = {
    addRemovePartner: 'ADD_RM_PARTNER',
    editDefaultContact: 'EDIT_DEFAULT_CONTACT',
    editCompanyLogo: 'EDIT_COMPANY_LOGO',
    regularDiscounts: 'REGULAR_DISCOUNTS',
    valutraxDiscounts: 'VTRX_DISCOUNT_ACCESS',
    specialPricingDiscounts: 'NONVALUTRAX_DISCOUNT_ACCESS',
    setupShopIntegrations: 'PROV_INT',
    collisionDiscount: 'COLLISION_DISCOUNT'
  };
}

export interface Codes {
 addRemovePartner: string;
 editDefaultContact: string;
 editCompanyLogo: string;
 regularDiscounts: string;
 valutraxDiscounts: string;
 specialPricingDiscounts: string;
 setupShopIntegrations: string;
 collisionDiscount: string;
}
